import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const Italic: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.8274 4.50028H14.8947C14.878 4.49991 14.8614 4.49991 14.8448 4.50028H10.3452C9.72064 4.50028 9.21429 5.01686 9.21429 5.65409C9.21429 6.29132 9.72064 6.80789 10.3452 6.80789H13.1127L8.48605 17.1921H5.25595C4.63134 17.1921 4.125 17.7087 4.125 18.3459C4.125 18.9832 4.63134 19.4997 5.25595 19.4997H9.18867C9.20532 19.5001 9.22195 19.5001 9.23856 19.4997H13.7381C14.3627 19.4997 14.869 18.9832 14.869 18.3459C14.869 17.7087 14.3627 17.1921 13.7381 17.1921H10.9707L15.5973 6.80789H18.8274C19.452 6.80789 19.9583 6.29132 19.9583 5.65409C19.9583 5.01686 19.452 4.50028 18.8274 4.50028Z"
      fill="currentColor"
    />
  </svg>
);
